import { InjectionToken } from '@angular/core';

/** Products API url injection token */
export const PRODUCTS_API_TOKEN = new InjectionToken<string>(
  'Products API url',
);

export const PRODUCTS_SEARCH_API_TOKEN = new InjectionToken<string>(
  'Products Search API url',
);

/** Products API url injection token */
export const SIZE_RUNS_API_TOKEN = new InjectionToken<string>(
  'Size-runs API url',
);
